import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-md-primary/30 focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-md-primary text-md-on-primary hover:bg-md-primary/80",
        secondary:
          "border-transparent bg-md-secondary-container text-md-on-secondary-container hover:bg-md-secondary-container/80",
        tertiary:
          "border-transparent bg-md-tertiary text-md-on-tertiary hover:bg-md-tertiary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        success:
          "border-transparent bg-success text-success-foreground hover:bg-success/80",
        warning:
          "border-transparent bg-warning text-warning-foreground hover:bg-warning/80",
        info:
          "border-transparent bg-info text-info-foreground hover:bg-info/80",
        "primary-container":
          "border-transparent bg-md-primary-container text-md-on-primary-container hover:bg-md-primary-container/80",
        "secondary-container":
          "border-transparent bg-md-secondary-container text-md-on-secondary-container hover:bg-md-secondary-container/80",
        "tertiary-container":
          "border-transparent bg-md-tertiary-container text-md-on-tertiary-container hover:bg-md-tertiary-container/80",
        outline: "text-md-on-surface border-md-outline",
        static: "border-transparent bg-md-primary text-md-on-primary",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }